import { useState } from "react";
import { RotateCw, Lock, ExternalLink } from "lucide-react";

export default function SafariWindow({ url }) {
  const target = url || "https://findleystmedia.com";
  const [frameError, setFrameError] = useState(false);
  const [key, setKey] = useState(0);
  const host = target.replace(/^https?:\/\//, "").replace(/\/.*$/, "");

  return (
    <div className="h-full flex flex-col bg-white" data-testid="safari-window-content">
      <div className="flex items-center gap-2 px-3 py-2 bg-[#f2f2f4] border-b border-black/10 shrink-0">
        <button data-testid="safari-reload" onClick={() => { setFrameError(false); setKey((k) => k + 1); }} className="p-1 rounded hover:bg-black/5">
          <RotateCw size={14} className="text-gray-600" />
        </button>
        <div className="flex-1 flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-md bg-white border border-black/10 text-[12px] text-gray-600">
          <Lock size={11} /> {host}
        </div>
        <a data-testid="safari-open-external" href={target} target="_blank" rel="noreferrer" className="p-1 rounded hover:bg-black/5">
          <ExternalLink size={14} className="text-gray-600" />
        </a>
      </div>
      <div className="flex-1 relative">
        {frameError ? (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 p-6 text-center bg-gradient-to-b from-gray-50 to-white">
            <div className="text-2xl font-bold text-gray-800">{host}</div>
            <p className="text-sm text-gray-500 max-w-xs">
              This site doesn't allow being shown inside other sites. Open it in a new tab instead.
            </p>
            <a data-testid="safari-open-site-btn" href={target} target="_blank" rel="noreferrer"
              className="px-5 py-2.5 rounded-full bg-sky-500 text-white text-sm font-semibold hover:bg-sky-600 transition">
              Open site
            </a>
          </div>
        ) : (
          <iframe
            key={key}
            src={target}
            title={host}
            className="absolute inset-0 w-full h-full border-0"
            onError={() => setFrameError(true)}
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          />
        )}
      </div>
    </div>
  );
}
